<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
        <div class="card-title">
            <h5 style="text-align: start">{{ title }}</h5>
        </div>
        
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-show="!topProspects?.length" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
            <div v-show="topProspects?.length" class="p-5">
              <canvas id="kt_chartjs_top_clients" class="mh-200px"></canvas>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import { onMounted, shallowRef, ref, watch} from 'vue';
import { useStore } from 'vuex';
import {$formatLocalAmount} from "@/mixins/Helpers";
import Loader from '@/components/Loader.vue';

const store = useStore()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    opportunity_id: '',
    seller_id: '',
    status: 'WON'
})

const topProspects = ref([])
const chartTopClientRef = shallowRef(null)

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})


function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }

  if(query.value.start_date && query.value.end_date){
    Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, opportunity_id: query.value.opportunity_id, seller_id: query.value.seller_id, status: query.value.status}).then((res) => {
          topProspects.value = res?.data?.topProspects || res?.response?.topProspects

        }),

    ]).then(() => {
      chartTopClient()
    })
  }  
}

function chartTopClient() {
    const ctx = document.getElementById('kt_chartjs_top_clients').getContext('2d');
    if (ctx) {
      if(Chart.getChart("kt_chartjs_top_clients")) {
        Chart.getChart("kt_chartjs_top_clients")?.destroy()
      }
    }
    const data = []
    topProspects.value?.forEach(item => {
       data.push({
        name: item.prospect_name,
        amount: item.total_expected_income,
        count: item.count
       })
    })

    let config = {
      type: 'bar',
      data: {
        labels: data.map(item => item.name),
        datasets: [{
          label: i18n.global.t('pipelines.label.prospect'),
          data: data.map(item => item.amount),
          backgroundColor: data.map(item => '#0072CE'),
          borderColor: data.map(item => '#0056A1'),
          borderRadius: 10,
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        plugins: {
          tooltip: {
            callbacks: {
              label: function(context) {
                return `${context.label}: ${$formatLocalAmount(context.raw)} ${defaultCurrency.value?.symbol}`;
              }
            }
          }
        },
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false
            }
          },
          y: {
            stacked: true,
            beginAtZero: true
          }
        }
      }
    };

    if (!chartTopClientRef.value) {
      chartTopClientRef.value = new Chart(ctx, config);
    }else{
      chartTopClientRef.value.destroy()
      chartTopClientRef.value = new Chart(ctx, config);
    }
  }

onMounted(() => {
  if(props.start) query.value.start_date = props.start
  if(props.end) query.value.end_date = props.end
})
</script>